

window.addEventListener("load", function () {

    $("#vxphl-ld-25-a-header").each(function () {
        var $btn = $(this).find(".MS__sprite-f1-btn-small").first();
        if (!$btn.length) {
            return;
        }

        var status = "off";
        if ($(this).hasClass("received")) {
            status = "received";
        } else if ($(this).hasClass("active")) {
            status = "active";
        }

        var text = $btn.attr("data-" + status);
        if (text) {
            $btn.text(text);
        }
    });

    var audio = null;
    $('#vxphl-ld-25-a-header .btn-music').on('click', function (e) {
        e.preventDefault();

        var $btn = $(this);
        var audioSrc = $btn.attr('data-music');
        if (!audioSrc) return;

        if (!audio) {
            audio = document.createElement('audio');
            audio.src = audioSrc;
            document.body.appendChild(audio);

            audio.onended = function () {
                $btn.removeClass('active');
            };
        }

        if (audio.getAttribute('src') !== audioSrc) {
            audio.pause();
            audio.src = audioSrc;
            audio.load();
        }

        if (audio.paused || audio.ended) {
            audio.play().then(function () {
                $btn.addClass('active');
            }).catch(function (err) {
                console.warn('Audio play failed:', err);
            });
        } else {
            audio.pause();
            $btn.removeClass('active');
        }
    });
});
